'use client'

import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import Image from 'next/image'
import styles from '@/components/homes/home-9/Hero.module.css'

import 'swiper/css'
import 'swiper/css/pagination'

const getHref = (item) => {
  if (item.IsInternalURL) {
    return item?.LinkURL
      ? `${item?.LinkURL?.trim()}${item.LinkURLPagePara?.trim() || ''}`
      : '#'
  } else {
    return item?.ExternalURL?.trim() || '#'
  }
}

export default function Hero({ banner = [] }) {
  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 5000 }}
      slidesPerView={1}
      loop
      className="mySwiper hero-swiper w-100"
      pagination={true}
    >
      {banner.map((elm, i) => (
        <SwiperSlide key={i} className="swiper-slide">
          <div className="overflow-hidden position-relative w-100">
            <div style={{ width: '100%' }}>
              <Link href={getHref(elm)}>
                <>
                  {/* 電腦版 Banner */}
                  {elm.ComputerPicturePath && (
                    <Image
                      src={elm.ComputerPicturePath}
                      alt=""
                      width={1920}
                      height={640}
                      className={styles.desktopBanner}
                    />
                  )}

                  {/* 手機版 Banner */}
                  {(elm.MobilePicturePath || elm.ComputerPicturePath) && (
                    <Image
                      src={elm.MobilePicturePath || elm.ComputerPicturePath}
                      alt=""
                      width={768}
                      height={768}
                      className={styles.mobileBanner}
                    />
                  )}
                </>
              </Link>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
